import { Checkbox, CheckboxProps } from "@mantine/core"

type Props = Omit<CheckboxProps, "disabled"> & {
  /** false → disabled and clearly grey (filled gray.3), so selectable rows stand out (user 2026-11-04). */
  selectable: boolean
}

const OFF_STYLES: CheckboxProps["styles"] = {
  input: {
    backgroundColor: "var(--mantine-color-gray-3)",
    borderColor: "var(--mantine-color-gray-4)",
    cursor: "not-allowed",
    opacity: 1,
  },
}

/** List row selector: one look in every list (Борлуулалт, Худалдан авалт, …). Wrap with DisabledReason for the «why» popover. */
export function RowCheckbox({ selectable, styles, ...rest }: Readonly<Props>) {
  return <Checkbox {...rest} disabled={!selectable} styles={selectable ? styles : { ...(typeof styles === "object" ? styles : {}), ...OFF_STYLES }} />
}
